(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsDeleteController', CompanyServantsDeleteController);

    CompanyServantsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Servant'];

    function CompanyServantsDeleteController($uibModalInstance, entity, servant) {
        var vm = this;

        vm.comapnyServants = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {

            servant.delete({id: vm.comapnyServants.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
